<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()" [style.background-image]="logo$ | async"></a>
  </div>

  <app-root-entities-switcher></app-root-entities-switcher>
</div>

<div class="header-container">
  <nb-actions size="small">
    <nb-action
      class="control-item"
      icon="question-mark-circle-outline"
      nbTooltip="Project Documentation"
      nbTooltipPlacement="bottom"
      link="/documentation"
    ></nb-action>

    <nb-action
      (click)="toggleThemeState()"
      class="control-item"
      [icon]="themeIcon"
      nbTooltip="Change theme"
      nbTooltipPlacement="bottom"
    ></nb-action>

    @if (metaAppUrl) {
      <nb-action
        [href]="metaAppUrl"
        (click)="openMetaApp()"
        nbTooltip="Open Project Settings"
        nbTooltipPlacement="bottom"
        class="control-item"
        icon="settings-2-outline"
      ></nb-action>
    }

    @if (isHealthCheckNotificationsVisible) {
      <nb-action class="control-item health-check-messages-button">
        <implto-user-notifications caption="System Health Notifications">
          <ng-template
            let-notification="notification"
            let-isRead="isRead"
            let-markAsRead="markAsRead"
            let-deleteButtonClicked="deleteButtonClicked"
          >
            <implto-health-check-message
              [message]="notification"
              [read]="isRead"
              (markAsRead)="markAsRead(notification, $event)"
              (deleted)="deleteButtonClicked(notification)"
            ></implto-health-check-message>
          </ng-template>
        </implto-user-notifications>
      </nb-action>
    }

    <nb-action class="user-action" nbTooltip="User settings" nbTooltipPlacement="bottom">
      <nb-user
        [nbContextMenu]="userMenu"
        nbContextMenuTag="userMenu"
        [onlyPicture]="userPictureOnly"
        [name]="user?.name"
        [title]="user?.email"
        [picture]="user?.photoUrl"
      ></nb-user>
    </nb-action>
  </nb-actions>
</div>
